export function truncateString(str: string, length: number = 40): string {
  if (str.length <= length) {
    return str;
  }
  return str.slice(0, length) + '…';
}

export function getDomainFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname;
  } catch (e) {
    return '';
  }
}
